export default "__VITE_ASSET__ECUFKsaK__"